import { FunctionalComponent, h } from "preact";
import { Link } from "preact-router";
import { DelYeahContainer } from "../../../containers/DelYeahContainer";
import { NextIcon } from "../../../icons/Next";
import { LayoutStyled } from "./my-history.style";
import { link } from '@authentic/loyalty-pwa/util';


export const DelYeahMyHistory: FunctionalComponent = () => {
  const htmlTitle: string = 'Del Yeah! Rewards History';
  const htmlMetaDescription: string = 'Your Del Yeah! Rewards Dashboard of available rewards and offers.';
  const IDItemMenuSelected: string = '6';
  return (
    <DelYeahContainer htmlTitle={htmlTitle} htmlMetaDescription={htmlMetaDescription} IDItemMenuSelected={IDItemMenuSelected}>
      <LayoutStyled>
        <p>Want to learn more about your points? Choose an option below.</p>
        <ul class="my-history-menu">
          <li>
            <Link href={link("/view-history")}>
              View History
              <NextIcon></NextIcon>
            </Link>
          </li>
          <li>
            <Link href={link("/enter-receipt")}>
              Enter Receipt
              <NextIcon></NextIcon>
            </Link>
          </li>
        </ul>
      </LayoutStyled>
    </DelYeahContainer >
  )
}
